import React from 'react'
import { CARD_IMAGE, CLASSNAMES_BASED_ON_CARD, TABLE_HEADINGS, TABLE_HEADINGS_FOR_ARCTRYX } from './constants'
import SVGIcons from '../../../../../../Components/SVGIcons'
import { NO_DATA_MESSAGE } from '../../constants'
import { FEEDBACK_360_SURVEY } from '../../../../../../../config/questionTypeConstants'


export default function ArcteryxVisualizationCard(props) {


    return (

        <div className={`matrixvisulaization-card  ${props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? 'arcteryx' : ''}`}>
            <div className='matrixvisulaization-card__head'>
                <h3>
                    {props.currentData.title ? props.currentData.title : ''}
                </h3>
                <div className='iconbx-arcteryx'>
                    <img src={CARD_IMAGE[props.currentKey]} alt="card-icon" />
                </div>
            </div>
            <table className={`matrixvisulaization-card__table`}>
                <tbody>
                    {props.currentData && props.currentData.tableValues.length > 0 ? (
                        props.currentData.tableValues.map((currentRow, idx) => (
                            <tr key={idx} className={`matrixvisulaization-card__table--top`}>
                                <td width={150} className='matrixvisulaization-card__table--category'>
                                    {currentRow.category}
                                </td>
                                <td className='matrixvisulaization-card__table--left'>
                                    {currentRow.behaviour}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr className="nodata"><td className='' height={100} colSpan={4}>{NO_DATA_MESSAGE}</td></tr>
                    )}
                </tbody>
            </table>

        </div>
    )
} 